import { Col, Divider, message, Row, Upload, Select, Form as FormInicial } from "antd";
import React, { Component } from "react";
import { connect } from "react-redux";
import {
    ButtonItem,
    Form,
    ModalItem,
    FormItem,
    InputItem,
    InputNumberItem,
    ErrorItem,
    HeaderItem,
    BoxItem,
    SelectItem,
    DatePickerItem,
    TextAreaItem,
} from "../../../../Components/Items";
import { DeleteOutlined, EyeOutlined, MinusCircleOutlined, PlusOutlined, UploadOutlined } from "@ant-design/icons";
import moment from "moment";
import axios from "axios";

const { Option } = Select;

function getBase64(file) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
    });
}

class EditarLote extends Component {
    formRef = React.createRef();
    state = {
        loading: false,
        archivos: [],
        imagenes: [],
        previewImage: '',
        previewVisible: false,
        previewTitle: '',
        previewImageArchivo: '',
        previewVisibleArchivo: false,
        previewTitleArchivo: '',
        todasInsumosVenta: [],
        objetoInsumosVenta: null,
    };

    componentDidUpdate(prevProps) {
        if (this.props.visible !== prevProps.visible && this.props.visible) {
            this.consultarInformacionLote();
        }

    }

    consultarInformacionLote() {
        this.setState({ loading: true });
        axios.post("lotes/datosLote", {
            loteId: this.props.loteId,
            empresaId: this.props.empresaId,
        }, {
            headers: this.props.headersToken,
        }).then((res) => {
            if (res.data.success === 2) {
                const archivos = Array.isArray(res.data.lote?.archivos) ? res.data.lote.archivos.map(valueArch => {
                    return {
                        ...valueArch,
                        url: valueArch.url ? ((process.env.NODE_ENV === "development" ? "http://192.168.100.6:3001/../" : "../") + valueArch.url) : "",
                    }
                }) : [];
                const imagenes = Array.isArray(res.data.lote?.imagenes) ? res.data.lote.imagenes.map(valueImg => {
                    return {
                        ...valueImg,
                        url: valueImg.url ? ("../" + valueImg.url) : "",
                    }
                }) : [];
                this.setState({
                    loading: false,
                    archivos,
                    imagenes,
                    insumo: res.data.insumo,
                    todasInsumosVenta: res.data.insumosVenta,
                    objetoInsumosVenta: res.data.insumosVenta.map((value) => {
                        return (
                            <Option value={value._id} key={value._id}>
                                {value.stringBuscar}
                            </Option>
                        );
                    }),
                });
                this.formRef.current.setFieldsValue({
                    ...res.data.lote,
                    archivos,
                    imagenes,
                    fechaEntrega: res.data.lote.fechaEntrega ? moment(res.data.lote.fechaEntrega) : null,
                    fechaIngresoM: res.data.lote.fechaIngresoM ? moment(res.data.lote.fechaIngresoM) : null,
                    fechaPedimento: res.data.lote.fechaPedimento ? moment(res.data.lote.fechaPedimento) : null,
                    caducidad: res.data.lote.caducidad ? moment(res.data.lote.caducidad) : null,
                });
            } else {
                message.error("Error al consultar la información del lote");
            }
        })
    }

    cerrarEditarLote(e) {

        this.props.cerrarEditarLote(e);
        this.setState({
            archivos: [],
            imagenes: [],
        });
        this.formRef.current.resetFields();
    }

    onFinish(values) {
        this.setState({ loading: true });
        axios.post("lotes/editarLote", {
            loteId: this.props.loteId,
            empresaId: this.props.empresaId,
            ...values,
            archivos: this.state.archivos,
            imagenes: this.state.imagenes,
        }, {
            headers: this.props.headersToken,
        }).then((res) => {
            this.setState({ loading: false });
            if (res.data.success === 2) {
                message.success("Lote editado correctamente");
                this.cerrarEditarLote({ cerrarModificado: true });
            } else {
                message.error("Error al editar el lote");
            }
        })
    }

    onFinishFailed(e) {
        ErrorItem(e);
    }

    async customRequestImagenes(e) {
        const file = e.file;
        const isImage = ['image/jpeg', 'image/png', 'image/webp'].includes(file.type);
        const isLt5M = file.size / 1024 / 1024 < 25;

        if (!isImage) {
            message.error(`${file.name} no es un tipo de imagen válido`);
            e.onError('Tipo de archivo inválido');
            return;
        }

        if (!isLt5M) {
            message.error(`${file.name} supera los 25 MB`);
            e.onError('Archivo demasiado grande');
            return;
        }

        const base64 = await getBase64(file);

        const newFile = {
            uid: file.uid,
            name: file.name,
            status: 'done',
            url: base64, // Esto permite mostrar la imagen y hacer preview
            originFileObj: file,
        };

        this.setState((prev) => {
            const anterior = prev?.imagenes || [];
            return {
                imagenes: [...anterior, newFile],
            };
        });

        e.onSuccess("ok");
    }

    beforeUploadImagenes(file) {
        const isImage = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/webp';
        if (!isImage) {
            message.error(`${file.name} no es un tipo de imagen válido (JPEG/PNG/WEBP)`);
            return Upload.LIST_IGNORE;
        }

        const isLt5M = file.size / 1024 / 1024 < 25;
        if (!isLt5M) {
            message.error(`${file.name} excede el tamaño máximo de 5MB`);
            return Upload.LIST_IGNORE;
        }

        return true;
    }

    onRemoveFileImagenes = (file) => {
        const archivos = this.state?.imagenes || [];
        const filtrado = archivos.filter((item) => item.uid !== file.uid);

        this.setState({
            imagenes: filtrado,
        });
    };

    handlePreview = async (file) => {
        if (!file.url && !file.preview) {
            file.preview = await getBase64(file.originFileObj);
        }
        this.setState({
            previewImage: file.url || file.preview,
            previewVisible: true,
            previewTitle: file.name || '',
        });
    };

    handleCancel = () => this.setState({ previewVisible: false });

    customRequestArchivos = async (e) => {
        const file = e.file;
        const isPDF = file.type === 'application/pdf';
        const isLt5M = file.size / 1024 / 1024 < 25;

        if (!isPDF) {
            message.error(`${file.name} no es un archivo PDF válido`);
            e.onError('Tipo de archivo inválido');
            return;
        }

        if (!isLt5M) {
            message.error(`${file.name} supera los 25 MB`);
            e.onError('Archivo demasiado grande');
            return;
        }

        const base64 = await getBase64(file);

        const nuevoArchivo = {
            uid: file.uid,
            name: file.name,
            status: 'done',
            url: base64,
            originFileObj: file,
        };

        this.setState((prev) => {
            const anteriores = prev.archivos || [];
            return {
                archivos: [...anteriores, nuevoArchivo],
            };
        });

        e.onSuccess("ok");
    };

    beforeUploadArchivos = (file) => {
        const isPDF = file.type === 'application/pdf';
        const isLt5M = file.size / 1024 / 1024 < 25;

        if (!isPDF) {
            message.error(`${file.name} no es un archivo PDF válido`);
            return Upload.LIST_IGNORE;
        }

        if (!isLt5M) {
            message.error(`${file.name} excede el tamaño máximo de 25MB`);
            return Upload.LIST_IGNORE;
        }

        return true;
    };

    onRemoveFileArchivos = (file) => {
        const archivos = this.state?.archivos || [];
        const filtrado = archivos.filter((item) => item.uid !== file.uid);

        this.setState({
            archivos: filtrado,
        });
    };

    handlePreviewArchivo = async (file) => {
        if (!file.url && !file.preview) {
            file.preview = await getBase64(file.originFileObj);
        }
        this.setState({
            previewImageArchivo: file.url || file.preview,
            previewVisibleArchivo: true,
            previewTitleArchivo: file.name || '',
        },);
    };

    handleCancelArchivo = () => this.setState({ previewVisibleArchivo: false });

    quitarArchivos = (index) => {
        this.setState({
            imagenes: [],
            archivos: [],
        });
    }

    render() {

        const ediciones = this.props.ediciones || {};

        return (
            <>
                <ModalItem
                    title={this.props.taxidermia ? "Editar Animal" : "Editar Lote"}
                    visible={this.props.visible}
                    spinning={this.state.loading}
                    onCancel={this.cerrarEditarLote.bind(this)}
                    paddingTop
                    width={1000}
                >
                    <Divider>{this.props.taxidermia ? "Animal" : "Lote"}</Divider>
                    <Form
                        ref={this.formRef}
                        name="editarLote"
                        layout
                        bottom={
                            <ButtonItem
                                type="primary"
                                htmlType="submit"
                                style={{ display: "block", margin: "0 0 0 auto" }}
                            >
                                Editar
                            </ButtonItem>
                        }
                        onFinish={this.onFinish.bind(this)}
                        onFinishFailed={this.onFinishFailed}
                    >
                        <Row >
                            <Col span={12}>
                                <FormItem
                                    label="Numero"
                                    name={"numero"}
                                    fieldKey={"numero"}
                                    required
                                    margin
                                >
                                    <InputItem disabled={!ediciones.editarNumero && this.props.cancelarEdiciones} placeholder="Ej. 210158" />
                                </FormItem>
                                <FormItem
                                    label="Fecha Caducidad"
                                    name={"caducidad"}
                                    fieldKey={"caducidad"}
                                    margin
                                >
                                    <DatePickerItem
                                        placeholder="Fecha de Caducidad"
                                        style={{ width: "100%" }}
                                        format="DD/MM/YYYY"
                                    />
                                </FormItem>
                                {this.props.taxidermia && (
                                    <>
                                        <FormItem
                                            label="Tipo Especie"
                                            name={"tipoEspecie"}
                                            fieldKey={"tipoEspecie"}
                                            margin
                                            required={ediciones.editarTipoEspecieRequerido}
                                        >
                                            <InputItem disabled={!ediciones.editarTipoEspecie && this.props.cancelarEdiciones} placeholder="Ej. León africano" />
                                        </FormItem>
                                        <FormItem
                                            label="Fecha Ingreso"
                                            name={"fechaIngresoM"}
                                            fieldKey={"fechaIngresoM"}
                                            margin
                                            required={ediciones.editarFechaIngresoRequerido}
                                        >
                                            <DatePickerItem
                                                disabled
                                                placeholder="Fecha Ingreso Mexico"
                                                style={{ width: '100%' }}
                                                format="DD/MM/YYYY"
                                            />
                                        </FormItem>
                                    </>
                                )}
                            </Col>
                            <Col span={12}>
                                <FormItem
                                    label="Cantidad"
                                    name={"cantidad"}
                                    fieldKey={"cantidad"}
                                    required
                                    margin
                                >
                                    <InputNumberItem disabled placeholder="Cantidad" />
                                </FormItem>
                                {this.props.taxidermia && (
                                    <>
                                        <FormItem
                                            label="Tipo Permiso"
                                            name={"tipoPermiso"}
                                            fieldKey={"tipoPermiso"}
                                            margin
                                            required={ediciones.editarTipoPermisoRequerido}
                                        >
                                            <SelectItem placeholder="Tipo Permiso" disabled={!ediciones.editarTipoPermiso && this.props.cancelarEdiciones}>
                                                <Option value="SEMARNAT">SEMARNAT</Option>
                                                <Option value="CINTILLO">CINTILLO</Option>
                                                <Option value="CITES">CITES</Option>
                                                <Option value="APROVECHAMIENTO">APROVECHAMIENTO</Option>
                                            </SelectItem>
                                        </FormItem>
                                        <FormItem
                                            label="Permiso"
                                            name={"permisoCaza"}
                                            fieldKey={"permisoCaza"}
                                            margin
                                            required={ediciones.editarPermisoRequerido}
                                        >
                                            <InputItem placeholder="Ej. Derecha" disabled={!ediciones.editarPermiso && this.props.cancelarEdiciones} />
                                        </FormItem>
                                    </>
                                )}
                            </Col>
                        </Row>
                        {this.state?.insumo?.vehiculo && (
                            <Row>
                                <Col span={12}>
                                    <FormItem
                                        label="Color"
                                        name={"color"}
                                        fieldKey={"color"}
                                        margin
                                    >
                                        <InputItem placeholder="Ej. Rojo metálico" />
                                    </FormItem>

                                    <FormItem
                                        label="NIV"
                                        name={"niv"}
                                        fieldKey={"niv"}
                                        margin
                                    >
                                        <InputItem placeholder="Ej. 3GNAXSEFXKS123456" />
                                    </FormItem>

                                    <FormItem
                                        label="No. Motor"
                                        name={"numeroMotor"}
                                        fieldKey={"numeroMotor"}
                                        margin
                                    >
                                        <InputItem placeholder="Número de motor" />
                                    </FormItem>

                                </Col>

                                <Col span={12}>
                                    <FormItem
                                        label="Pedimento"
                                        name={"numeroPedimento"}
                                        fieldKey={"numeroPedimento"}
                                        margin
                                    >
                                        <InputItem placeholder="Número de pedimento" />
                                    </FormItem>

                                    <FormItem
                                        label="Fecha Pedimento"
                                        name={"fechaPedimento"}
                                        fieldKey={"fechaPedimento"}
                                        margin
                                    >
                                        <DatePickerItem
                                            placeholder="Fecha de pedimento"
                                            style={{ width: "100%" }}
                                            format="DD/MM/YYYY"
                                        />
                                    </FormItem>

                                    <FormItem
                                        label="Aduana"
                                        name={"aduana"}
                                        fieldKey={"aduana"}
                                        margin
                                    >
                                        <InputItem placeholder="Ej. Manzanillo" />
                                    </FormItem>

                                    <FormItem
                                        label="Clave Vehicular"
                                        name={"claveVehicular"}
                                        fieldKey={"claveVehicular"}
                                        margin
                                    >
                                        <InputItem placeholder="Clave vehicular SAT" />
                                    </FormItem>
                                </Col>
                            </Row>
                        )}
                        {this.props.taxidermia && (
                            <>
                                <HeaderItem>PIEZAS</HeaderItem>
                                <BoxItem>
                                    <FormInicial.List name={"piezas"}>
                                        {(piezasFields, { add: addPieza, remove: removePieza }) => (
                                            <>
                                                {piezasFields.map(({ key: piezaKey, name: piezaName, fieldKey: piezaFieldKey, ...piezaRestField }, piezaArrayKey) => (
                                                    <Row key={piezaArrayKey}>
                                                        <Col span={11}>
                                                            <FormItem
                                                                {...piezaRestField}
                                                                label="Pieza"
                                                                name={[piezaName, "descripcion"]}
                                                                fieldKey={[piezaFieldKey, "descripcion"]}
                                                                required
                                                                margin
                                                            >
                                                                <SelectItem placeholder="Pieza">
                                                                    <Option value="Entero">Entero</Option>
                                                                    <Option value="Copina">Copina</Option>
                                                                    <Option value="Medio Cuerpo">Medio Cuerpo</Option>
                                                                    <Option value="Backskin">Backskin</Option>
                                                                    <Option value="Panel">Panel</Option>
                                                                    <Option value="Cuernos">Cuernos</Option>
                                                                    <Option value="Craneo">Craneo</Option>
                                                                    <Option value="Huesos">Huesos</Option>
                                                                    <Option value="Cola">Cola</Option>
                                                                    <Option value="Patas">Patas</Option>
                                                                    <Option value="Colmillos">Colmillos</Option>
                                                                    <Option value="Garras">Garras</Option>
                                                                </SelectItem>
                                                            </FormItem>
                                                        </Col>
                                                        <Col span={11}>
                                                            <FormItem
                                                                {...piezaRestField}
                                                                label="Cantidad"
                                                                name={[piezaName, "cantidad"]}
                                                                fieldKey={[piezaFieldKey, "cantidad"]}
                                                                required
                                                                margin
                                                                initialValue={1}
                                                            >
                                                                <InputNumberItem disabled placeholder="Cantidad" />
                                                            </FormItem>
                                                        </Col>
                                                        <Col span={2}>
                                                            <MinusCircleOutlined onClick={() => removePieza(piezaName)} />
                                                        </Col>
                                                    </Row>
                                                ))}
                                                <Row>
                                                    <Col span={24} style={{ textAlign: 'center' }}>
                                                        <ButtonItem lessTime type="dashed" onClick={() => addPieza()} icon={<PlusOutlined />}>
                                                            Agregar Pieza
                                                        </ButtonItem>
                                                    </Col>
                                                </Row>
                                            </>
                                        )}
                                    </FormInicial.List>
                                </BoxItem>
                            </>
                        )}
                        <HeaderItem>OBSERVACIONES</HeaderItem>
                        <BoxItem>
                            <Row>
                                <Col span={24}>
                                    <FormItem
                                        label="Observaciones"
                                        name={"observaciones"}
                                        fieldKey={"observaciones"}
                                        margin
                                        labelCol={{ span: 4 }}
                                        wrapperCol={{ span: 20 }}
                                        required={ediciones.editarObservacionesRequerido}
                                    >
                                        <TextAreaItem
                                            disabled={!ediciones.editarObservaciones && this.props.cancelarEdiciones}
                                            placeholder="Observaciones"
                                        />
                                    </FormItem>
                                </Col>
                            </Row>
                        </BoxItem>
                        <HeaderItem>ARCHIVO GRAFICO</HeaderItem>
                        <BoxItem>
                            <Row>
                                <Col span={12}>
                                    <FormItem
                                        name={"archivos"}
                                        fieldKey={"archivos"}
                                        margin
                                        style={{
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            textAlign: "center",
                                        }}
                                        required={ediciones.editarArchivoGraficoRequerido}
                                    >
                                        <Upload
                                            accept=".pdf"
                                            showUploadList={{
                                                showRemoveIcon: true,
                                                showPreviewIcon: true,
                                                previewIcon: <EyeOutlined style={{ color: '#1890ff' }} />,
                                                removeIcon: <DeleteOutlined style={{ color: 'red' }} />,
                                            }}
                                            fileList={this.state.archivos || []}
                                            customRequest={(e) => this.customRequestArchivos(e)}
                                            beforeUpload={this.beforeUploadArchivos}
                                            onRemove={(file) => this.onRemoveFileArchivos(file)}
                                            onPreview={this.handlePreviewArchivo.bind(this)}
                                            disabled={!ediciones.editarArchivoGrafico && this.props.cancelarEdiciones}
                                        >
                                            {this.state.archivos?.length >= (this.props.taxidermia ? 5 : 3) ? null :
                                                <ButtonItem icon={<UploadOutlined />} disabled={!ediciones.editarArchivoGrafico && this.props.cancelarEdiciones} style={{ padding: '0px 20px' }}>
                                                    Archivos
                                                </ButtonItem>
                                            }
                                        </Upload>
                                    </FormItem>
                                </Col>
                                <Col span={12}>
                                    <FormItem
                                        name={"imagenes"}
                                        fieldKey={"imagenes"}
                                        margin
                                        style={{
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            textAlign: "center",
                                        }}
                                        required={ediciones.editarArchivoGraficoRequerido}
                                    >
                                        <Upload
                                            disabled={!ediciones.editarArchivoGrafico && this.props.cancelarEdiciones}
                                            accept=".jpg,.jpeg,.png,.webp"
                                            listType="picture-card"
                                            showUploadList={{
                                                showRemoveIcon: true,
                                                showPreviewIcon: true,
                                            }}
                                            fileList={this.state?.imagenes || []}
                                            customRequest={(e) => this.customRequestImagenes(e)}
                                            beforeUpload={this.beforeUploadImagenes}
                                            onRemove={(file) => this.onRemoveFileImagenes(file)}
                                            onPreview={this.handlePreview.bind(this)}
                                        >
                                            {this.state?.imagenes?.length >= (this.props.taxidermia ? 10 : 3) ? null :
                                                <div>
                                                    <PlusOutlined />
                                                    <div style={{ marginTop: 8 }}>Imagenes</div>
                                                </div>
                                            }
                                        </Upload>
                                    </FormItem>
                                </Col>
                            </Row>
                        </BoxItem>
                    </Form>
                    <ModalItem
                        visible={this.state.previewVisible}
                        title={this.state.previewTitle}
                        footer={null}
                        onCancel={this.handleCancel}
                        spinning={false}
                    >
                        <img alt="example" style={{ width: "100%" }} src={this.state.previewImage} />
                    </ModalItem>
                    <ModalItem
                        visible={this.state.previewVisibleArchivo}
                        title={this.state.previewTitleArchivo}
                        footer={null}
                        onCancel={this.handleCancelArchivo}
                        spinning={false}
                    >
                        <iframe
                            src={this.state.previewImageArchivo}
                            title="Vista previa PDF"
                            style={{ width: '100%', height: '80vh', border: 'none' }}
                        />
                    </ModalItem>
                </ModalItem>
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        headersToken: state.user.headersToken,
        empresaId: state.empresa.id,
        taxidermia: state.empresa.taxidermia,
    };
};

export default connect(mapStateToProps)(EditarLote);
